export interface CustomCartItem extends BaseCartItem {
  code: string;
  name: string;
  price: number;
}

export interface CartItem extends BaseCartItem {
  sku: number | string;
}

interface BaseCartItem {
  quantity: number;
  callback_id: string;
}

// eslint-disable-next-line no-shadow
export enum EventNames {
  cartCallback = 'primeflow:cart:add:callback',
  cartOpen = 'primeflow:cart:open',
  cartAdd = 'primeflow:cart:add',
  cartAddCustom = 'primeflow:cart:add:custom-item'
}